import { render, staticRenderFns } from "./Governance.vue?vue&type=template&id=4aac51fa&"
import script from "./Governance.vue?vue&type=script&lang=js&"
export * from "./Governance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports